import type { ShippingFeePayer } from './shippingTotals';

/** Bốn nguồn quyết định số COD mặc định của đơn giao hàng. */
export interface DebtResetInputs {
  payable: number;
  shippingFee: number;
  feePayer: ShippingFeePayer;
  prepaidAmount: number;
}

/**
 * Có phải xoá số nợ thu ngân đã gõ hay không.
 *
 * Bất kỳ nguồn nào trong bốn nguồn trên đổi là số COD mặc định đổi theo, và số
 * nợ cũ không còn tương ứng với đơn nào nữa. Reset thay vì kẹp trần: giữ lại
 * một con số tính trên giỏ hàng cũ là cách chắc chắn nhất để ghi nợ sai mà
 * không ai nhận ra.
 *
 * KHÔNG xét chính `debtAmount`: thu ngân gõ COD chỉ đổi số nợ, không đổi bốn
 * nguồn kia — nếu xét thì mỗi lần gõ sẽ tự xoá cái vừa gõ.
 */
export function shouldResetDebt(prev: DebtResetInputs, next: DebtResetInputs): boolean {
  return (
    prev.payable !== next.payable ||
    prev.shippingFee !== next.shippingFee ||
    prev.feePayer !== next.feePayer ||
    prev.prepaidAmount !== next.prepaidAmount
  );
}
